import { Component } from '@angular/core';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import {
  ClientGroupData
} from '@app/features/main/views/_tb/tb-users/modals/tb-user-create-edit-modal/tb-user-create-modal.component';
import { PermissionAware } from '@app/shared/decorators/permissions-awareness.decorator';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'group-grid-cell',
  template: `

    <div id="cell-container" [style.justify-content]="side === 'Left' ? 'space-between' : 'flex-start'">
      @if (side === 'Left') {
        <span>{{ params.value }}</span>
      }

      @if (showButton) {
        <button (click)="toggleGroup(params.action)" color="primary" mat-icon-button
                class="fx-layout-row fx-justify-center fx-align-center"
                [disabled]="(params.action === 'Add') && data?.groupInfo?.isGroupFromClientPresent">
          <mat-icon fontSet="mdi" [fontIcon]="params.actionIcon" class="msm"></mat-icon>
        </button>

      }
      @if (side !== 'Left') {
        <span>{{ params.value }}</span>
      }

    </div>
  `,
  styles: [`
    #cell-container {
      display: flex;
      align-items: center;
      height: 100%;
      overflow-x: auto;
      overflow-y: hidden;
    }
  `],
  standalone: false
})
@PermissionAware
export class GroupGridCellComponent implements ICellRendererAngularComp {

  public Permission = PermissionEnum;

  public params: Partial<ICellRendererParams & {
    actionIcon: string,
    action: 'Add' | 'Remove',
    side: 'Left' | 'Right'
  }>;
  public data: ClientGroupData;
  public side: string;
  public icon: string;
  public showButton: boolean;

  /**
   * Method used by Ag-grid to initialise the cell with grid parameters
   * @param params
   */
  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;
    this.side = this.params.side;


    // Show the button if the tree level is more than 1
    this.showButton = this.data.groupInfo?.treeData.split(' | ').length > 1;
  }

  public toggleGroup(action: 'Add' | 'Remove'): void {
    if (action === 'Add') {
      this.data.groupInfo?.toggleButton.setValue(true);
    } else if (action === 'Remove') {
      this.data.groupInfo?.toggleButton.setValue(false);
    }
  }

  /**
   * Method used by Ag-Grid to tell the grid to refresh this cell
   * This component does not include refresh logic
   * @param params
   * @returns {boolean}
   */
  public refresh(params: any): boolean {
    return false;
  }
}
